<script setup lang="ts">
import type { SellerLink } from './LinkTabletCol.vue'

const t2 = useT2({
  Faq: 'DUK',
  Shops: 'Parduotuvės',
  'Product care': 'Prekių priežiūra',
  Fabrics: 'Audiniai',
  Certificates: 'Sertifikatai',
  'Privacy policy': 'Privatumo politika',
  'Cookie policy': 'Slapukų politika',
  'Help center': 'Pagalbos centras',
  'Product guide': 'Prekių gidas',
  'Size guides': 'Dydžių lentelės',
  Policies: 'Politika',
  'Company Details': 'Įmonės rekvizitai',
})

const { myLink, linkPrivacy, linkCookiePolicy, linkTerms } = useLinks()

// import type { RouteLocationRaw } from '#vue-router'

// type RouteName = { title: stringI18n; to: RouteLocationRaw }
// type RouteLins = RouteName & { children?: RouteName[] }

// const infoLinks: RouteLins[] = [
//   // {
//   //   title: t2('FAQ'),
//   //   to: myLink('info', {}),
//   // },
//   // { title: t2('Order tracking'), to: myLink('info-track-order', {}) },
//   // { title: t2('Returns and Refunds'), to: myLink('info-returns', {}) },
//   // {
//   //   title: t2('Gift Cards'),
//   //   to: myLink('info-gift', {}),
//   //   children: [
//   //     { title: t2('Buy'), to: myLink('info-gift', {}) },
//   //     { title: t2('Check balance'), to: myLink('user-gift-balance', {}) },
//   //   ],
//   // },
//   // { title: t2('B2B'), to: myLink('b2b', {}) },
//   { title: t2('Privacy policy'), to: linkPrivacy },
//   { title: t2('Cookie policy'), to: linkCookiePolicy },
//   { title: t2('Terms and conditions'), to: linkTerms },
// ] satisfies RouteLins[]

defineProps<{ profile?: boolean }>()
// const mobile = useMobile()

type LinkTuples = [route: string, title: stringI18n]

const sellerFull = useSeller('server')
const routeName = useParams((_, fullRoute) => myLinkName(fullRoute))

function objToLinks(val: LinkTuples[], route: (typeof routeName.value), seller: string | undefined) {
  return val.map(([key, label]): SellerLink => ({
    active: route === key || !!route?.includes(key),
    label,
    key,
    to: seller ? myLink(key, { }) : undefined,
  }))
}

const ui2 = computed(() => {
  const seller = sellerFull.handle.value
  const doc = sellerFull.seller.value?.doc
  const handle = doc?.handle
  const rn = routeName.value
  const about: LinkTuples = ['info-about', t2('About us')]

  const linksHelp = [
    ...(doc?.aboutUs?._id ? [about] : []),
    ['info-company', t2('Company Details')],
    ['info-delivery', t2('Shipping & Delivery')],
    ['info-returns', t2('Returns & Refunds')],
    ['info-shops', t2('Shops')],
    ['info-factory', t2('Factories')],
  ] satisfies LinkTuples[]

  const linksProd = [
  // ['info-size-guide', 'Size guide'],
    ['info-care', t2('Product care')],
    ['info-size-guides', t2('Size guides')],
    ['info-fabrics', t2('Fabrics')],
    ['info-certificates', t2('Certificates')],
    ['info-warranty', t2('Warranty')],
  ] satisfies LinkTuples[]

  const policies = [
    { label: t2('Privacy policy'), to: linkPrivacy },
    { label: t2('Cookie policy'), to: linkCookiePolicy },
    { label: t2('Terms and conditions'), to: linkTerms },
  ]

  const faq: SellerLink = {
    active: helpers.isIn(routeName.value, 'info-faq', 'info-faq-slug', 'info-faq-slug-slug2'),
    key: 'faqqq',
    label: t2('Faq'),
    to: seller ? myLink('info-faq') : undefined,
  }

  return {
    help: [faq, ...objToLinks(linksHelp, rn, handle)],
    guide: objToLinks(linksProd, rn, handle),
    profile: doc?._uiProfile,
    render: !!handle,
    policies: policies.map((item, index): SellerLink => {
      return {
        ...item,
        to: item.to?.(),
        key: index.toString(),
        active: !!rn?.startsWith(myLinkName(item.to()) || ''),
      }
    }),
  }
})
</script>

<template>
  <div :class="$style.c">
    <template v-if="profile">
      <!-- <h3 class="_pb2" :class="mobile ? '_pl1' : '_pl4'">{{ t2('Customer Care') }}</h3> -->
      <UiGrow :open="!!ui2.profile">
        <ProfileBox v-if="ui2.profile" social seller vertical :profile="ui2.profile" :class="$style.p" class="_pl4 m_pl1" />
      </UiGrow>
    </template>
    <!-- <InputInfoSearch :class="$style.search" /> -->
    <div :class="$style.col" class="_col _pt4 _gap4">
      <LinkTabletCol :label="t2('Information')" :links="ui2.help" />
      <LinkTabletCol :label="t2('Product guide')" :links="ui2.guide" />
      <LinkTabletCol :label="t2('Policies')" :links="ui2.policies" />
    </div>
  </div>
</template>

<style module>
:global(.d) .c {
  margin-left: -20px
}
</style>
